<template>
  <div class="tags-page">
    <div class="container">
      <div v-if="studyId" class="tags-page__header d-flex">
        <router-link v-if="this.$route.name == 'data-capture-form-activity-details'" :to="{ name: 'forms-list', params: { mode: mode } }" class="d-block tags-page__back-to-activities fs-14">Data Capture Forms&nbsp;</router-link>
        <router-link v-else :to="{ name: 'study-activities' }" class="d-block tags-page__back-to-activities fs-14">Activities&nbsp; </router-link>
        <span>/ Activity Information</span>
      </div>
      <div v-else class="tags-page__header d-flex">
        <router-link :to="{ name: 'activity-library-homepage', params: { mode: mode } }" class="d-block tags-page__back-to-activities fs-14">Activity Library&nbsp;</router-link>
        <span>/ Activity Configurator</span>
      </div>

      <activityform :therapeuticAreas="therapeuticAreas" :activityTypes="activityTypes" :formConfig="formConfig" @onActivitySubmit="createActivity" :languages="languages" :tags="tags" :groups="groups" :key="'lang' + 1" :is-published-edit="isPublishedEdit" />
    </div>
  </div>
</template>

<script>
import swal from "sweetalert2";
import { saveAuditDetails } from "../configurator/util/saveAuditDetails"
import activityform from "@/components/activity-library/activity-form";
import localStorage from "@/services/localStorage";

export default {
  name: "activity-create",
  components: {
    activityform
  },
  data() {
    return {
      therapeuticAreas: [],
      activityTypes: [],
      groups: [],
      formConfig: {},
      languages: {},
      tags: {},
      activityId: undefined,
      revisionId: null,
      studyId: null,
      mode: "",
      taskId: null
    };
  },
  computed: {
    isPublishedEdit() {
      return this.$route.query.ispublished == 1;
    }
  },
  methods: {
    init() {
      this.activityId = this.$route.params.activityId;
      this.revisionId = this.$route.query.revisionId;
      this.studyId = this.$route.params.studyId ? this.$route.params.studyId : this.$route.query.studyId;
      this.mode = this.$route.params.mode ? this.$route.params.mode : this.$route.query.mode;
      this.taskId = this.$route.params.taskId;
      localStorage.removeItem("taskId");
      localStorage.setItem("taskId", this.taskId);
      this.getActivityFormConfig();
      this.getActivityTypes();
      this.getTherapeuticAreas();
      this.getTagsList();
      this.fetchSupportedLanguages();
      this.getOrganizations();
    },
    getTherapeuticAreas() {
      this.$api
        .getTherapeuticAreas()
        .then(response => {
          this.therapeuticAreas = response.data.result;
        })
        .catch(() => {
          this.$toastr.error("Error in getting Therapeutic Areas");
        });
    },
    getOrganizations() {
      this.$api
        .getOrganizations()
        .then(response => {
          this.groups = response.data.result;
        })
        .catch(() => {
          this.$toastr.error("Error in getting Organizations list");
        });
    },
    getActivityTypes() {
      this.$api
        .getActivityTypes()
        .then(response => {
          this.activityTypes = response.data.result;
        })
        .catch(() => {
          this.$toastr.error("Error in getting Therapeutic Areas");
        });
    },
    getTagsList() {
      this.$api
        .getActivityTags({})
        .then(response => {
          this.tags = response.data.result.rows;
        })
        .catch(() => {
          this.$toastr.error("Error while getting tags list");
        });
    },
    getActivityFormConfig() {
      this.$api.getActivityFormConfig().then(response => {
        this.formConfig = response.data.result;
      });
    },
    createActivity(oldActivity, activity, revisionId, autoSave = false) {
      activity.pinStatus = 0;
      /** Reverse Logic based on variable */
      activity.showNumericLabels = !activity.hideNumericLabels;
      if (activity.id != undefined && activity.id !== 0) {
        if (activity.activityId == undefined) {
          activity.activityId = this.activityId;
        }
        this.$api
          .updateActivity(this.activityId, activity)
          .then(response => {

            const apiURL = response.url.substring(response.url.indexOf("/api"));
            const auditDetails = {
              "section": "Customize",
              "element": "Activity",
              "httpMethod": "POST",
              "url": apiURL,
              "changeFrom": oldActivity || {},
              "changeTo": response.body.result,
            };
            saveAuditDetails(this.$api, this.studyId, auditDetails);

            if (!autoSave) {
              this.$toastr.success("Activity updated successfully");
              if (this.isPublishedEdit) {
                this.$router.push({ name: "activity-library-homepage" });
              } else {
                if (this.studyId) {
                  this.$router.push({
                    name: this.$route.name == "data-capture-form-activity-details" ? "data-capture-form-activity-questions" : "activity-questions",
                    params: { activityId: activity.id, mode: this.mode, studyId: this.studyId },
                    query: { mode: this.mode }
                  });
                } else {
                  this.$router.push({
                    name: "activity-questions",
                    params: { activityId: activity.id },
                    query: { mode: this.mode, revisionId: revisionId }
                  });
                }
              }
            }
          })
          .catch(error => {
            this.$toastr.error(error.body ? error.body.message : "Error while updating the activity");
          });
      } else {
        if (this.mode == "revise") {
          this.$api
            .verifyActivity(activity)
            .then(response => {
              const alreadyDraftPresent = response.body.result.alreadyDraftPresent;
              if (alreadyDraftPresent == true) {
                if (!autoSave) {
                  swal({
                    title: "A draft of this activity is already in the workspace. If you send this version to the workspace, your current draft will be overwritten? Are you sure you want to replace the current draft?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#b8c7ce",
                    cancelButtonColor: "#f16559",
                    confirmButtonText: "No",
                    cancelButtonText: "Yes"
                  }).then(({ dismiss }) => {
                    if (dismiss === "cancel") {
                      this.callCreateActivity(oldActivity, activity, revisionId);
                    }
                  });
                }
              } else {
                if (this.mode == "copy") {
                  activity.activityId = undefined;
                }
                if (!autoSave) {
                  this.callCreateActivity(oldActivity, activity, revisionId);
                } else {
                  this.callCreateActivity(oldActivity, activity, revisionId, autoSave);
                }
              }
            })
            .catch(error => {
              this.$toastr.error(error.body ? error.body.message : "Error while creating the activity");
            });
        } else {
          if (this.mode == "copy") {
            activity.activityId = undefined;
          }
          if (!autoSave) {
            this.callCreateActivity(oldActivity, activity, revisionId);
          } else {
            this.callCreateActivity(oldActivity, activity, revisionId, autoSave);
          }
        }
      }
    },
    callCreateActivity(oldActivity, activity, revisionId, autoSave = false) {
      /** Reverse Logic based on variable */
      activity.showNumericLabels = !activity.hideNumericLabels;
      activity.mode = this.mode;
      activity.isEdit = !!this.$route.query.isEdit;
      this.studyId = this.studyId ? this.studyId : null;
      this.$api
        .createActivity(this.studyId, activity)
        .then(response => {

          const apiURL = response.url.substring(response.url.indexOf("/api"));
          const auditDetails = {
            "section": "Customize",
            "element": "Activities",
            "httpMethod": "POST",
            "url": apiURL,
            "changeFrom": oldActivity || {},
            "changeTo": response.body.result,
          };
          saveAuditDetails(this.$api, this.studyId, auditDetails);

          if (!autoSave) {
            this.$toastr.success("Activity created successfully");
          }
          if (autoSave) {
            if (this.mode == "copy") {
              this.mode = "edit";
            }
          }
          if (this.studyId) {
            if (!autoSave) {
              this.$router.push({
                name: this.$route.name == "data-capture-form-activity-details" ? "data-capture-form-activity-questions" : "activity-questions",
                params: {
                  activityId: response.body.result.id,
                  mode: this.mode,
                  studyId: this.studyId,
                  taskId: this.taskId
                },
                query: { mode: this.mode, studyId: this.studyId }
              });
            } else {
              this.$router.push({
                name: this.$route.name == "data-capture-form-activity-details" ? "data-capture-form-activity-details" : "activity-details",
                params: {
                  activityId: response.body.result.id,
                  mode: this.mode,
                  studyId: this.studyId
                },
                query: { mode: this.mode, studyId: this.studyId }
              });
            }
          } else {
            if (!autoSave) {
              this.$router.push({
                name: "activity-details",
                params: { activityId: response.body.result.id },
                query: { mode: this.mode, revisionId: revisionId }
              });
              this.$router.push({
                name: "activity-questions",
                params: {
                  activityId: response.body.result.id,
                  mode: this.mode,
                  taskId: this.taskId
                },
                query: { mode: this.mode, revisionId: revisionId }
              });
            } else {
              this.$router.push({
                name: "activity-details",
                params: {
                  activityId: response.body.result.id,
                  mode: this.mode,
                  taskId: this.taskId
                },
                query: { mode: this.mode, revisionId: revisionId }
              });
            }
          }
        })
        .catch(error => {
          this.$toastr.error(error.body ? error.body.message : "Error while creating the activity");
        });
    },
    fetchSupportedLanguages() {
      this.$api
        .getSupportedClientLanguages()
        .then(
          response => {
            if (response.body.length == 0) {
              return;
            }
            this.languages = response.body;
          },
          () => {
            this.$toastr.error("Error occurred while fetching languages.");
          }
        )
        .catch(error => {
          this.$toastr.error(error.body ? error.body.message : "Error occurred while fetching languages.");
        });
    }
  },
  mounted() {
    this.init();
  },
  watch: {
    $route(to, from) {
      if (to.params.activityId != from.params.activityId) {
        this.init();
      }
    }
  }
};
</script>

<style scoped lang="scss">
.tags-page {
  font-family: "RobotoRegular";

  &__back-to-activites {
    color: #4c8ce4;
  }

  .container {
    max-width: 90%;
  }

  &__header {
    margin: 100px auto 0 auto;

    &__add-tag-btn {
      width: 116px;
      height: 35px;
      border-radius: 4px;
      background-color: #4c8ce4;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.43;
      letter-spacing: normal;
      color: #ffffff;
    }
  }

  .manage-tags-text {
    height: 24px;
    font-family: "RobotoRegular";
    font-size: 18px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.33;
    letter-spacing: normal;
    color: #000000;
  }

  .manage-tags-description {
    font-family: "RobotoRegular";
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.71;
    letter-spacing: normal;
    color: #000000;
  }

  .add-tag-modal {
    .modal-dialog {
      vertical-align: top !important;
      top: 100px;
    }

    &__container {
      width: 902px;
      height: 219px;
      border-radius: 4px;
      background-color: #ffffff;

      .fw-bold {
        font-weight: bold;
      }

      .color-black {
        color: black;
      }
    }

    &__name-input {
      width: 220px;
      height: 35px;
      border-radius: 3px;
      border: solid 1px #d3dfe4;
    }

    &__desc-input {
      width: 549px;
      height: 35px;
      border-radius: 3px;
      border: solid 1px #d3dfe4;
    }

    &__add-another-tag {
      font-family: "RobotoRegular";
      font-size: 12px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.67;
      letter-spacing: normal;
      color: #4c8ce4;
      cursor: pointer;
    }

    &__save-tag-btn {
      width: 102px;
      height: 35px;
      border-radius: 4px;
      background-color: #4c8ce4;
      color: white;
    }
  }
}
</style>
